// 引用pages
import pwdedit from '@/views/webpc/UserMgmt/login/pwdedit.vue'

// 定义路由路径数组列表
export default [{
  path: '/pwdedit',
  icon: 'el-icon-edit',
  name: '修改密码',
  component: pwdedit
}]



// WEBPACK FOOTER //
// ./src/views/webpc/UserMgmt/login/routers/index.js